import {updateEndFilter} from "../../event.js";
import {widgetBoard} from "../../index.js";
import u from "../../../../util/index.js";
import * as constants from "../../widgetConstants.js";
import {WIDGET} from "../../widgetConstants.js";

export const clickMemberWidget = (e, _this) => {

    const $w = $(_this.$target).closest('.widget-my-member');
    const $eTarget = $(e.target);

    /*필터버튼*/
    if ($eTarget.closest('.button-filter').length > 0) {
        const $pop = $w.find('.widget-filter-mini-pop');
        $pop.toggleClass('d-none');
    }

    /*멤버 아이템 */
    if ($eTarget.closest('.js-member-item').length > 0) {
        const memberData = $eTarget.closest('.js-member-item').data();
        Profile.drawProfilePopup(memberData.userId);
    }

    /*초대하기 아이템 */
    if ($eTarget.closest('.js-member-invite').length > 0) {
        InviteEmployee.toggleInviteEmployeeLayer();
    }

    /*필터팝업*/
    if ($eTarget.closest('.js-filter-input').length > 0) {
        if (!$eTarget.closest('.js-filter-input').length) return;

        //필터 업데이트
        const id = $eTarget.closest('.js-filter-input').attr('id')
        const WIDGET_USER_SRNO = id.split('_')[0];
        _this.$props.FIL_END_DT_GUBUN = id.split('_')[2];
        $(`#${WIDGET_USER_SRNO} > ul > li:first`).attr('fil_end_dt_gubun', _this.$props.FIL_END_DT_GUBUN);
        updateEndFilter(e, _this.$props.FIL_END_DT_GUBUN).then(r => {
            widgetBoard.$state.member.setup({
                isDataDrivenRendering: true,
                isInit: true,
                keySrno: WIDGET.MEMBER.INDEX_KEY_SRNO,
                API_KEY: WIDGET.MEMBER.API.API_KEY[Number(_this.$props.FIL_END_DT_GUBUN) === 3? 0 : 1],
                RECORD: WIDGET.MEMBER.API.RECORD[Number(_this.$props.FIL_END_DT_GUBUN) === 3? 0 : 1]
            })
        });

        //툴팁 업데이트
        updateToolTip($w, _this);

        //팝업
        const $pop = $eTarget.closest('.widget-filter-mini-pop');
        $pop.toggleClass('d-none');
    }

}

function updateToolTip($w, _this) {
    const filter = Number(u.n2v(_this.$props.FIL_END_DT_GUBUN, "1"));
    const $filterBtn = $w.find('.button-filter span');
    if (filter === 3) {
        $filterBtn.removeClass('js-mouseover js-button-tooltip')
            .attr('mouseover-text', '')
    } else {
        $filterBtn.addClass('js-mouseover js-button-tooltip')
            .attr('mouseover-text',
                filter === 1 ?
                    i18next.t(main.orderByRecentCollabo)
                    : i18next.t(main.orderByFrequentCollabo)
            )
    }
    $filterBtn.text(i18next.t(constants.member_filter[_this.$props.FIL_END_DT_GUBUN - 1]));

}
